import { Box, Button, Typography } from "@mui/material";
import axios from "axios";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../redux/userSlice";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/logo.png"
import Loader from "./Loader";

const Login = () => {
  const [loginData, setLoginData] = useState();
  const [error, setError] = useState();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.user.user);
  const [isLoading, setIsLoading] = useState();

  const handleChange = (e) => {
    setLoginData({ ...loginData, [e.target.name]: e.target.value });
  };

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_BACKEND_URL}/auth/signin`,
        { username: loginData.username, password: loginData.password }
      );
      dispatch(setUser(res.data));
      setIsLoading(false)
      if(res.data.userRole.includes("ADMIN")){
        navigate("/admin-dashboard")
      } else {
        navigate("/dashboard");
      }
    } catch (error) {
      setIsLoading(false);
      setError("Invalid credentails! Please enter valid mobile number or password")
      console.log(error);
    }
  };

  useEffect(() => {
    const storedUser = localStorage.getItem("user");
    if(storedUser){
      const parsedUser = JSON.parse(storedUser);
      dispatch(
        setUser(parsedUser)
      );
      if(parsedUser.userRole.includes("ADMIN")){
        navigate("/admin-dashboard");
      } else {
        navigate('/dashboard')
      }
    }
  }, []);

  return (
    <Box>
      {isLoading ? <Loader /> :
      <Box
        className="parent-div"
        sx={{
          justifyContent: { xs: "normal", md: "space-between" },
          alignItems: { xs: "normal", md: "center" },
          flexDirection: { xs: "column", md: "row" },
        }}
      >
        <span className="eclipse1"></span>
        <span className="eclipse2"></span>
        <span className="eclipse3"></span>
        <Box
          sx={{
            padding: "40px 20px",
            zIndex: 100,
            position: "relative",
            display: { xs: "block", md: "none" },
          }}
        >
          <Typography className="heading">Login To Your Account</Typography>
        </Box>
        <Box sx={{ display: { xs: "flex", md: "none" }, flex: 1 }}>
          <form
            style={{ display: "flex", flexDirection: "column", flex: 1 }}
            className="main-container"
          >
            <input
              type="text"
              name="username"
              placeholder="Mobile No"
              onChange={handleChange}
            />
            <input
              type="password"
              name="password"
              placeholder="Password"
              onChange={handleChange}
            />
            {error && <Typography sx={{color: 'red', fontSize: '12px', marginLeft: '25px'}}>{error}</Typography>}
            <Typography textAlign={"center"}>
              Don't have an account?<br/><a href="/register">Sign Up</a>
            </Typography>
            <Link to={"/forgot-password"}>
              <Typography textAlign={"center"}>Forgot Password</Typography>
            </Link>
            <Button variant="contained" onClick={handleLogin}>
              Login
            </Button>
          </form>
        </Box>
  
        {/* Desktop */}
        <Box
          sx={{
            padding: "40px 20px",
            zIndex: 100,
            position: "relative",
            display: { xs: "none", md: "block" },
            mx: 10
          }}
        >
          <img src={logo} alt="Company logo" width={200} />
        </Box>
        <Box sx={{ display: { xs: "none", md: "block" } }} mx={10}>
          <form
            style={{ display: "flex", flexDirection: "column" }}
            className="login-desktop"
          >
            <Typography
              sx={{
                color: "#301B52",
                fontSize: "48px",
                fontWeight: 700,
                lineHeight: "56px",
                textAlign: "center",
              }}
            >
              Login
            </Typography>
            <input
              type="text"
              name="username"
              id="username"
              placeholder="Mobile No"
              onChange={handleChange}
            />
            <input
              type="password"
              name="password"
              id="password"
              placeholder="Password"
              onChange={handleChange}
            />
            {error && <Typography sx={{color: 'red', fontSize: '12px', marginLeft: '25px'}}>{error}</Typography>}
            {/* <Typography textAlign={"center"}>
              Don't have an account? <a href="/register">Sign Up</a>
            </Typography> */}
            <Link to={"/forgot-password"}>
              <Typography textAlign={"center"}>Forgot Password</Typography>
            </Link>
            <Button variant="contained" onClick={handleLogin} sx={{my: 2}}>
              Login
            </Button>
          </form>
        </Box>
      </Box>}
    </Box>
  );
};

export default Login;
